export const sensitiveFields: (string | RegExp)[] = [
  /password/i,
  /phone_number/i,
];
